module.exports = __webpack_public_path__ + "img/sol.27ba9679.svg";